import { ContentWrapper } from "../../components/Wrappers/Wrappers"
import { Title, Text } from "../../components/units/Text"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { useValidatePermission } from "../../roles/roles"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { CreateUserProps, AxiosCreateUser } from "../../components/Rest/RestUsers"
import { Input } from "../../components/Form/FormInput"
import { SubmitButton } from "../../components/Buttons/buttons"
import { RestApiState } from "../../components/Rest/Organization"
import { ImageInput } from "../../components/Form/ImageInput"
import { LgSelect } from "../../components/Form/FormInput"
import { useEffect, useState } from "react"
import { AxiosOrganizationOptions, OrganizationOptions } from "../../components/Rest/Organization"
import { PhoneInput_ } from "../../components/Form/FormInput"

interface ResponseProps {
    errors: {
        phone?: string;
        email?: string;
        organization_id?: string;
    },
    requestState: RestApiState;
    timeOutId: NodeJS.Timeout | undefined;
    created: boolean;
}


const defaultResponse = (): ResponseProps => {
    return {
        errors: {

        },
        requestState: RestApiState.Idle,
        timeOutId : undefined,
        created: false
    }
}


export const CreateUser = () => {
    const { user } = useSignedInContext()

    useValidatePermission({ role : user.role, resource: 'Users', action: 'create' })
    
    const [img, setImg] = useState(undefined)
    const [role, setRole] = useState(1)
    const [orgChoices, setOrgChoices] = useState<OrganizationOptions[]>([{id: "", organization_name: "Не выбрано"}])
    const [response, setResponse] = useState<ResponseProps>(defaultResponse)
    const [phone, setPhone] = useState<string>("")
    useEffect(() =>{
        AxiosOrganizationOptions((value: OrganizationOptions[]) => { setOrgChoices(prev => [...prev, ...value]) })
    }, [])

    useEffect(() => { 
        if (response.requestState === RestApiState.Success) {
            setResponse(prev => ({...prev,  created: true}))
        }
    }, [response.requestState])

    const handleSubmit = (event: any) => {
        event.preventDefault();
        setResponse(prev => ({...prev, errors:{}}))

        const formData = new FormData(event.currentTarget)
        const formValues: Record<string, any> = {};
        formData.forEach((value, key) => {
            formValues[key] = value as any; // Cast value to string if necessary
        });
        formValues['phone'] = phone
        formValues['username'] = formValues.email
        formValues['organization_id'] = formValues.organization_id !== "" ? formValues.organization_id : undefined
        if (formValues.role === '1' && formValues.organization_id === "") {
            setResponse(prev => ({...prev, errors: {
                ...prev.errors, organization_id: "Нужно выбрать организацию"
            }}))
            return ;
        }

        setResponse(prev => ({...prev, requestState: RestApiState.Pending}))
        AxiosCreateUser(
            (formValues as CreateUserProps), 
            (value: RestApiState) => {
                setResponse(prev => ({...prev, requestState: value}))
            },
            (value: any) => {
                for (const key of Object.keys(value)) {
                    setResponse(prev => ({...prev, errors: {
                        ...prev.errors, [key]: "Неверное значение или дубль"
                    }}))
                }
            }
        )
    }

    return (
        <ContentWrapper>
            <Title>Создать пользователя</Title>
            <br />
            <BoxWrapper 
                bg="bg-primary"
                p="p2"
                r="r10"
                style={{
                    maxWidth: "640px"
                }} 
            >
                { !response.created ? (
                    <form onSubmit={ handleSubmit }>
                        <FlexWrapper justifyContent="center">
                            <BoxWrapper>
                                <ImageInput 
                                    disabled={false}
                                    name="profile_image"
                                    size="base"
                                    defaultImg="profile"
                                    previewImg={img}
                                    setPreview={{
                                        action: "",
                                        key: "",
                                        setValue: (action:string, key:string, value: any) => { setImg(value) }
                                    }}
                                />
                                <Text color="secondary" className="text-center">Аватар</Text>
                            </BoxWrapper>
                        </FlexWrapper>
                        
                        <Input name="email"
                            label="Почта"
                            required={true}
                            type='text'
                            inputError={response.errors.email}
                        />
                        <PhoneInput_ name="phone"
                            value={phone}
                            setter={setPhone}
                            label="Телефон"
                            required={true}
                            type='text'
                            inputError={response.errors.phone}
                        />
                        <Input name="last_name"
                            label="Фамилия"
                            required={false}
                            type='text'
                        />
                        <Input name="first_name"
                            label="Имя"
                            required={false}
                            type='text'
                        />
                        <Input name="middle_name"
                            label="Отчество"
                            required={false}
                            type='text'
                        />
                        <LgSelect name={"role"}
                            label="Роль"
                            value={role}
                            valueSetter={( e: any ) => {
                                setRole(e.target.value)
                            }}
                            options={[
                                {
                                    value: 1, 
                                    label: "Клиент",
                                },
                                {
                                    value: 6, 
                                    label: "Завод",
                                },
                                {
                                    value: 7, 
                                    label: "Сервис",
                                },
                                {
                                    value: 8, 
                                    label: "Поддержка",
                                },
                            ]}
                        />
                        <LgSelect name={"organization_id"}
                            label="Организация"
                            valueSetter={( e: any ) => {
                                console.log(e.target.value)
                                // setRole(e.target.value)
                            }}
                            options={orgChoices.map(item => ({
                                value: item.id,
                                label: item.organization_name,
                            }))}
                            inputError={response.errors.organization_id}
                        />
                        <SubmitButton 
                            restState={response.requestState}
                            disabled={false}
                            restHandler={{
                                timeOutId: null,
                                setter: (key: "timeOutId" | "requestState", value: any) => {
                                    setResponse(prev => ({...prev, [key]: value}))
                                }
                            }}
                        />
                    </form>
                ) : (
                    <BoxWrapper className="show-up-quick">
                        <FlexWrapper>
                            <Text className="bold">Пользователь успешно создан ✅</Text>
                        </FlexWrapper>
                    </BoxWrapper>
                ) }
            </BoxWrapper>
        </ContentWrapper>
    )
}